<template>
    <modal title="QR Code">
        <a
            v-if="qrCode.toLowerCase().startsWith('http')"
            href="#"
            @click.prevent="Browser.open({ url: qrCode })"
            >{{ qrCode }}</a
        >
        <a
            v-else-if="
                qrCode.toLowerCase().startsWith('mailto') ||
                qrCode.toLowerCase().startsWith('tel') ||
                qrCode.toLowerCase().startsWith('sms')
            "
            :href="qrCode"
            target="_blank"
            >{{ qrCode }}</a
        >
        <div v-else-if="qrCode.toLowerCase().startsWith('matmsg')">
            <div class="ion-margin-bottom"><b>E-Mail Nachricht</b></div>
            An:
            {{ matmsg.to }}<br />
            Betreff:
            {{ matmsg.subject }}<br />
            Nachricht:
            {{ matmsg.body }}
        </div>
        <div v-else-if="qrCode.toLowerCase().startsWith('geo')">
            <p>{{ qrCode }}</p>
            Latitude:
            {{ latitude }}<br />
            Longitude:
            {{ longitude }}<br />
            <span v-if="height !== ''">Höhe: {{ height }} Meter</span>
        </div>
        <div v-else-if="qrCode.toLowerCase().startsWith('begin:vcard')">
            <div class="ion-margin-bottom"><b>Kontakt</b></div>
            <div v-if="vcard.fn[0].value">Name: {{ vcard.fn[0].value }}</div>
            <div v-if="vcard.org[0].value">
                Unternehmen: {{ vcard.org[0].value }}
            </div>
            <div v-if="vcard.title[0].value">
                Beruf: {{ vcard.title[0].value }}
            </div>
            <div v-if="vcard.adr[0].value[2]">
                Straße: {{ vcard.adr[0].value[2] }}
            </div>
            <div v-if="vcard.adr[0].value[3]">
                Stadt: {{ vcard.adr[0].value[3] }}
            </div>
            <div v-if="vcard.adr[0].value[5]">
                PLZ: {{ vcard.adr[0].value[5] }}
            </div>
            <div v-if="vcard.adr[0].value[4]">
                Bundesland: {{ vcard.adr[0].value[4] }}
            </div>
            <div v-if="vcard.adr[0].value[6]">
                Land: {{ vcard.adr[0].value[6] }}
            </div>
            <div v-if="vcard.tel[0].value">
                Telefon: {{ vcard.tel[0].value }}
            </div>
            <div v-if="vcard.tel[1].value">
                Mobiltelefon: {{ vcard.tel[1].value }}
            </div>
            <div v-if="vcard.tel[2].value">Fax: {{ vcard.tel[2].value }}</div>
            <div v-if="vcard.email[0].value">
                E-Mail: {{ vcard.email[0].value }}
            </div>
            <div v-if="vcard.url[0].value">
                Webseite: {{ vcard.url[0].value }}
            </div>
        </div>
        <span v-else>
            {{ qrCode }}
        </span>
        <template v-slot:footer>
            <ion-button
                v-if="qrCode.toLowerCase().startsWith('http')"
                expand="block"
                :href="qrCode"
                target="_blank"
                >Im Browser öffnen</ion-button
            >
            <ion-button
                v-else-if="
                    qrCode.toLowerCase().startsWith('mailto') ||
                    qrCode.toLowerCase().startsWith('tel')
                "
                expand="block"
                :href="qrCode"
                target="_blank"
                >{{
                    qrCode.toLowerCase().startsWith("mailto")
                        ? "E-Mail senden"
                        : "Nummer anrufen"
                }}</ion-button
            >
            <ion-button
                v-else-if="qrCode.toLowerCase().startsWith('matmsg')"
                expand="block"
                :href="
                    'mailto:' +
                    matmsg.to +
                    '?subject=' +
                    matmsg.subject +
                    '&body=' +
                    matmsg.body
                "
                target="_blank"
                >E-Mail senden</ion-button
            >
            <ion-button
                v-else-if="qrCode.toLowerCase().startsWith('sms')"
                expand="block"
                @click="sendSMS()"
                >SMS senden</ion-button
            >
            <ion-button
                v-else-if="qrCode.toLowerCase().startsWith('geo')"
                expand="block"
                :href="
                    'https://www.google.com/maps/dir/?api=1&destination=' +
                    latitude +
                    ',' +
                    longitude
                "
                target="_blank"
                >Auf Karte anzeigen</ion-button
            >
            <ion-button
                v-else-if="qrCode.toLowerCase().startsWith('begin:vcard')"
                expand="block"
                @click="addContact()"
                >Kontakt hinzufügen</ion-button
            >
            <ion-button v-else expand="block" @click="writeToClipboard(qrCode)"
                >Text kopieren</ion-button
            >
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
import { Plugins, registerWebPlugin } from "@capacitor/core";
import { SmsManager } from "@byteowls/capacitor-sms";
var vCard = require("vcard-parser");
import {
    Contacts,
    ContactField,
    ContactName,
    ContactOrganization,
    ContactAddress,
} from "@ionic-native/contacts";

const { Clipboard } = Plugins;

export default {
    components: {
        Modal,
    },
    props: {
        qrCode: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            Browser: Plugins.Browser,
        };
    },
    mounted() {
        registerWebPlugin(SmsManager);
    },
    computed: {
        latitude() {
            let result = "";
            if (this.qrCode.toLowerCase().startsWith("geo")) {
                result = this.qrCode.substring(
                    this.qrCode.indexOf(":") + 1,
                    this.qrCode.indexOf(",")
                );
            }
            return result;
        },
        longitude() {
            let result = "";
            if (this.qrCode.toLowerCase().startsWith("geo")) {
                let endIndex = "";
                if (this.qrCode.indexOf(",") === this.qrCode.lastIndexOf(",")) {
                    endIndex = this.qrCode.length;
                } else {
                    endIndex = this.qrCode.lastIndexOf(",");
                }
                result = this.qrCode.substring(
                    this.qrCode.indexOf(",") + 1,
                    endIndex
                );
            }
            return result;
        },
        height() {
            let result = "";
            if (
                this.qrCode.toLowerCase().startsWith("geo") &&
                this.qrCode.indexOf(",") !== this.qrCode.lastIndexOf(",")
            ) {
                result = this.qrCode.substring(
                    this.qrCode.lastIndexOf(",") + 1,
                    this.qrCode.length
                );
            }
            return result;
        },
        sms() {
            let result = {};
            result.number = "";
            result.message = "";
            if (this.qrCode.toLowerCase().startsWith("sms")) {
                let numberEndIndex = "";
                if (this.qrCode.indexOf(":") === this.qrCode.lastIndexOf(":")) {
                    numberEndIndex = this.qrCode.length;
                } else {
                    numberEndIndex = this.qrCode.indexOf(":", 6);
                    result.message = this.qrCode.substring(
                        numberEndIndex + 1,
                        this.qrCode.length
                    );
                }
                result.number = this.qrCode.substring(
                    this.qrCode.indexOf(":") + 1,
                    numberEndIndex
                );
            }
            return result;
        },
        matmsg() {
            let result = {};
            result.to = "";
            result.subject = "";
            result.body = "";
            const qrCodeLowerCase = this.qrCode.toLowerCase();
            if (qrCodeLowerCase.startsWith("matmsg")) {
                result.to = this.qrCode.substring(
                    qrCodeLowerCase.indexOf("to:") + 3,
                    qrCodeLowerCase.indexOf(";")
                );
                result.subject = this.qrCode.substring(
                    qrCodeLowerCase.indexOf("sub:") + 4,
                    qrCodeLowerCase.indexOf(";body")
                );
                result.body = this.qrCode.substring(
                    qrCodeLowerCase.indexOf("body:") + 5,
                    qrCodeLowerCase.length - 2
                );
            }
            return result;
        },
        vcard() {
            let result = {};
            if (this.qrCode.toLowerCase().startsWith("begin:vcard")) {
                result = vCard.parse(this.qrCode);
            }
            return result;
        },
    },
    methods: {
        addContact() {
            let lastname = this.vcard.n[0].value[0] || null;
            let firstname = this.vcard.n[0].value[1] || null;
            let mobile = this.vcard.tel[1].value || null;
            let tel = this.vcard.tel[0].value || null;
            let fax = this.vcard.tel[2].value || null;
            let org = this.vcard.org[0].value || null;
            let title = this.vcard.title[0].value || null;
            let street = this.vcard.adr[0].value[2] || null;
            let city = this.vcard.adr[0].value[3] || null;
            let postalCode = this.vcard.adr[0].value[5] || null;
            let state = this.vcard.adr[0].value[4] || null;
            let land = this.vcard.adr[0].value[6] || null;
            let email = this.vcard.email[0].value || null;
            let website = this.vcard.url[0].value || null;

            let contacts = new Contacts();
            let contact = contacts.create();
            contact.name = new ContactName(null, lastname, firstname);
            contact.phoneNumbers = [
                new ContactField("mobile", mobile, true),
                new ContactField("tel", tel, false),
                new ContactField("fax", fax, false),
            ];
            contact.organziations = [
                new ContactOrganization(true, "work", org, title),
            ];
            contact.addresses = [
                new ContactAddress(
                    true,
                    "home",
                    street,
                    city,
                    state,
                    postalCode,
                    land
                ),
            ];
            contact.emails = [new ContactField("work", email, true)];
            contact.urls = [new ContactField("work", website, true)];
            contact.save().then(
                () => {
                    this.$ionic.toastController
                        .create({
                            color: "dark",
                            duration: 2000,
                            message: "Kontakt wurde gespeichert",
                            showCloseButton: true,
                            closeButtonText: "Schließen",
                        })
                        .then((toast) => {
                            toast.present();
                        });
                },
                (error) => {
                    this.$ionic.alertController
                        .create({
                            header: "Bitte beachten",
                            message:
                                "Fehler beim Speichern des Kontakts: " + error,
                            buttons: ["OK"],
                        })
                        .then((a) => {
                            a.present();
                        });
                }
            );
        },
        sendSMS() {
            Plugins.SmsManager.send({
                numbers: [this.sms.number],
                text: this.sms.message,
            })
                .then(() => {
                    // SMS app was opened
                })
                .catch((error) => {
                    // see error codes below
                    let errorMessage = "";
                    if (error.message !== "SEND_CANCELLED") {
                        // show toast with error message
                        errorMessage = error.message ? error.message : "";
                    }
                    this.$ionic.alertController
                        .create({
                            header: "Bitte beachten",
                            message: error + ": " + errorMessage,
                            buttons: ["OK"],
                        })
                        .then((a) => {
                            a.present();
                        });
                });
        },
        writeToClipboard(text) {
            Clipboard.write({ string: text }).then(() => {
                this.$ionic.toastController
                    .create({
                        color: "dark",
                        duration: 2000,
                        message: "Text wurde kopiert",
                        showCloseButton: true,
                        closeButtonText: "Schließen",
                    })
                    .then((toast) => {
                        toast.present();
                    });
            });
        },
    },
};
</script>

<style></style>
